import axios, { getEnv } from './api';

const cardService = {
  buscarcards: async () => {
    try {
      const res = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/card`
      );
      return res;
    } catch (error) {
      return error;
    }
  },

  salvarcard: async (params) => {
    try {
      const res = await axios.post(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/card`,
        params
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  editCard: async (params) => {
    try {
      const res = await axios.put(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/card`,
        params
      );
      return res;
    } catch (error) {
      return error;
    }
  },

  deletarCard: async (params) => {
    try {
      const res = await axios.delete(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/card/deletar/${params}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },

  aprovar: async (id, visualizacao) => {
    const registers = {
      id: id,
      situacao: 'APROVADO',
      visualizacao: visualizacao,
    };

    try {
      const res = await axios.put(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/card`,
        registers
      );
      return res;
    } catch (error) {
      return error;
    }
  },
};

export default cardService;
